export const MIN_PROFICIENCY_GAP = 1
export const DEFAULT_ROLLUP_WEIGHT = 1

export type MasteryBucket = 'learning' | 'proficient' | 'mastered'

export function hasCustomRollupWeight(weight: number | undefined): boolean {
  return (
    Math.abs((weight ?? DEFAULT_ROLLUP_WEIGHT) - DEFAULT_ROLLUP_WEIGHT) > 0.001
  )
}

/** Display weight in subtitle tags (e.g. `wt 2`, `wt 1.5`). */
export function formatRollupWeight(weight: number | undefined): string {
  const value = weight ?? DEFAULT_ROLLUP_WEIGHT
  if (Number.isInteger(value)) return String(value)
  return value.toFixed(1).replace(/\.0$/, '')
}

export function weightedAverage(
  items: { value: number; weight: number }[],
): number {
  if (items.length === 0) return 0
  let weightedSum = 0
  let weightTotal = 0
  for (const { value, weight } of items) {
    if (weight <= 0) continue
    weightedSum += value * weight
    weightTotal += weight
  }
  if (weightTotal === 0) return 0
  return Math.round(weightedSum / weightTotal)
}

export function classifyMasteryBucket(
  current: number,
  min: number,
  max: number,
): MasteryBucket {
  if (current >= max) return 'mastered'
  if (current >= min) return 'proficient'
  return 'learning'
}

export function clampProficiencyRange(
  min: number,
  max: number,
): { minProficiencyThreshold: number; maxProficiencyThreshold: number } {
  let lo = Math.max(0, Math.min(100, min))
  let hi = Math.max(0, Math.min(100, max))
  if (lo > hi) {
    ;[lo, hi] = [hi, lo]
  }
  if (hi - lo < MIN_PROFICIENCY_GAP) {
    if (hi + MIN_PROFICIENCY_GAP <= 100) {
      hi = lo + MIN_PROFICIENCY_GAP
    } else if (lo - MIN_PROFICIENCY_GAP >= 0) {
      lo = hi - MIN_PROFICIENCY_GAP
    } else {
      lo = 0
      hi = MIN_PROFICIENCY_GAP
    }
  }
  return { minProficiencyThreshold: lo, maxProficiencyThreshold: hi }
}
